export const moduleSlug = 'catalogue'
export const moduleAuth = 'Configurations.Catalogue';
import MerchantPicker from "./components/CatalogueMerchantPicker.vue";
export const picker = MerchantPicker;
export const children = [
  {
    path: "",
    component: () => import("./pages/CatalogueMenu.vue"),
    props: {
      pageType: 'catalogue',
      tabName: 'catalogue'
    },
    meta: {
      title: "Catalog",
      linkTitle: "Catalog",
      linkIcon: "list",
      showInNav: true,
      permission: "Configurations.Catalogue",
    },
  },
  {
    path: "addons",
    component: () => import("./pages/CatalogueMenu.vue"),
    props: {
      pageType: 'catalogue',
       tabName: 'addons'
    },
    meta: {
      title: "Addons",
      linkTitle: "Addons",
      linkIcon: "cogs",
      showInNav: true,
      permission: "Configurations.Catalogue",
    },
  },
  // {
  //   path: "inventory",
  //   component: () => import("./pages/CatalogueMenu.vue"),
  //   props: {
  //     pageType: 'inventory'
  //   },
  //   meta: {
  //     title: "Inventory Catalogue",
  //     linkTitle: "Inventory Catalogue",
  //     linkIcon: "list-alt",
  //     showInNav: true,
  //     permission: "Configurations.Catalogue",
  //   },
  // },
  // {
  //   path: "product",
  //   component: () => import("./pages/CatalogueMenu.vue"),
  //   props: {
  //     pageType: 'product'
  //   },
  //   meta: {
  //     title: "Product Catalogue",
  //     linkTitle: "Product Catalogue",
  //     linkIcon: "th-list",
  //     showInNav: true,
  //     permission: "Configurations.Catalogue",
  //   }
  // },
  {
    path: "variants",
    component: () => import("./pages/Variants.vue"),
    meta: {
      title: "Variants",
      linkTitle: "Variants",
      linkIcon: "th-list",
      showInNav: true,
      permission: "Configurations.Catalogue",
    }
  },
  {
    path: "variants/catalogue",
    component: () => import("./pages/VariantCatalogues.vue"),
    props: route => ({
      merchantId: route.query.merchantId,
      variantId: route.query.variantId
    }),
    meta: {
      title: "Variants Catalogue",
      linkTitle: "Variants Catalogue",
      linkIcon: "th-list",
      showInNav: false,
      permission: "Configurations.Catalogue",
    }
  }
]